// removed by extract-text-webpack-plugin
module.exports = {"member-content":"Passenger__member-content__CZBfi","separator":"Passenger__separator__5n-LW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoting/Board/Passenger/Passenger.scss
// module id = 240
// module chunks = 0